import { PropsWithChildren } from 'react'
import {
  AnalyseContentModal,
  AnalyseContentModalProps,
} from 'screens/BrandKits/components/BrandVoice/AddVoice/AnalyseContentModal'
import { ErrorBoundary } from '@sentry/react'
import { useModals } from 'almanac-ui/Modal'
import { Importer } from '../ContentSourcePicker/ContentSourcePicker'

export const VoiceErrorBoundary = ({
  children,
  onAnalyse,
}: PropsWithChildren<Pick<AnalyseContentModalProps, 'onAnalyse'>>) => {
  const { closeModal } = useModals()

  return (
    <ErrorBoundary
      fallback={
        <AnalyseContentModal
          close={closeModal}
          onAnalyse={onAnalyse}
          selectedImporter={Importer.PasteWebsiteText}
          availableImporters={[
            Importer.ScanWebsite,
            Importer.PasteWebsiteText,
            Importer.SelectDoc,
            Importer.UploadFiles,
          ]}
          errorMessage="This site didn't allow auto-export"
        />
      }
    >
      {children}
    </ErrorBoundary>
  )
}
